/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import {
  Button,
  Grid,
  MenuItem,
  TextField,
  makeStyles,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'

import filterStylesComponents from '../../../../../assets/filterComponentsStyles'
import BaseFilterModal from '../../../../../components/hooks/BaseFilterModal'
import { SNACKBAR } from '../../../../main/MainActions'
import NumberFormatCustom from '../../../../components/NumberFormat'

const useStyles = makeStyles({
  formContainer: {
    width: '100%',
  },
})

const buildEmptyForm = fields =>
  fields.reduce((acc, field) => {
    acc[field.name] = field.defaultValue ?? ''
    return acc
  }, {})

const EnquadramentoFormModal = ({
  open,
  onClose,
  fields = [],
  editing = null,
  storeFn,
  updateFn,
  onSaved,
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const styles = filterStylesComponents()

  const [form, setForm] = useState(buildEmptyForm(fields))
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!open) return

    if (editing) {
      setForm(
        fields.reduce((acc, field) => {
          acc[field.name] = editing?.[field.name] ?? field.defaultValue ?? ''
          return acc
        }, {})
      )
    } else {
      setForm(buildEmptyForm(fields))
    }
  }, [open, editing])

  const handleClose = () => {
    if (saving) return
    onClose()
  }

  const buildPayload = () =>
    fields.reduce((acc, field) => {
      const value = form?.[field.name]

      if (value === '' || value === null || value === undefined) {
        acc[field.name] = field.required ? value : null
        return acc
      }

      if (field.type === 'number' || field.type === 'percentage') {
        acc[field.name] = Number(value)
      } else {
        acc[field.name] = value
      }

      return acc
    }, {})

  const handleSubmit = async e => {
    e.preventDefault()
    setSaving(true)

    try {
      const payload = buildPayload()

      const resp = editing?.id
        ? await updateFn(editing.id, payload)
        : await storeFn(payload)

      dispatch({
        type: SNACKBAR.SOFTSUCCESS,
        success: { message: 'Sucesso!' },
      })

      if (onSaved) onSaved(resp)
      onClose()
    } catch (err) {
      dispatch({
        type: SNACKBAR.HARDFAIL,
        error: { message: 'Erro ao salvar enquadramento!' },
      })
    } finally {
      setSaving(false)
    }
  }

  const renderField = field => {
    if (field.type === 'select') {
      return (
        <TextField
          select
          name={field.name}
          fullWidth
          label={field.label}
          required={field.required}
          helperText={field.helperText}
          value={form?.[field.name] ?? ''}
          onChange={e => setForm({ ...form, [field.name]: e.target.value })}
        >
          <MenuItem value="">Selecione...</MenuItem>
          {field.options?.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )
    }

    if (field.type === 'percentage') {
      return (
        <TextField
          fullWidth
          label={field.label}
          required={field.required}
          helperText={field.helperText}
          value={form?.[field.name] ?? ''}
          onChange={e => setForm({ ...form, [field.name]: e.target.value })}
          InputProps={{
            inputComponent: NumberFormatCustom,
            inputProps: {
              suffix: '%',
              style: { textAlign: 'left' },
              min: 0,
              max: 100,
            },
          }}
        />
      )
    }

    return (
      <TextField
        name={field.name}
        fullWidth
        label={field.label}
        required={field.required}
        helperText={field.helperText}
        type={field.type === 'number' ? 'number' : 'text'}
        value={form?.[field.name] ?? ''}
        onChange={e => setForm({ ...form, [field.name]: e.target.value })}
      />
    )
  }

  return (
    <BaseFilterModal
      open={open}
      handleOpen={handleClose}
      title={editing?.id ? 'Editar enquadramento' : 'Novo enquadramento'}
      hiddenHelpButton
      link=""
      paperWidth="600px"
    >
      <Grid item xs={12}>
        <form onSubmit={handleSubmit} className={classes.formContainer}>
          <Grid container spacing={3}>
            {fields.map(field => (
              <Grid item xs={12} md={field.md || 6} key={field.name}>
                {renderField(field)}
              </Grid>
            ))}

            <Grid
              item
              xs={12}
              container
              alignItems="center"
              justifyContent="center"
              style={{ marginTop: '8px' }}
            >
              <Button
                type="submit"
                className={styles.btnAdd}
                disabled={saving}
                style={{ padding: '4px 24px' }}
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </BaseFilterModal>
  )
}

export default EnquadramentoFormModal
